import { createFileRoute, useNavigate } from "@tanstack/react-router";

import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Divider,
} from "@nextui-org/react";
import { CustomButton } from "../custom/CustomButton";
import { queryClient } from "../main";
import { getOrganization } from "../openapi";
import { useMutation } from "@tanstack/react-query";
import {
  acceptInviteUserToOrganizationMutation,
  declineInviteUserToOrganizationMutation,
  usersCurrentUserQueryKey,
} from "../openapi/@tanstack/react-query.gen";

function NoOrganization() {
  const { organization } = Route.useLoaderData();
  const navigate = useNavigate();
  const { mutate: accept } = useMutation({
    ...acceptInviteUserToOrganizationMutation(),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: usersCurrentUserQueryKey(),
      });
      await navigate({ to: "/bi" });
    },
  });
  const { mutate: decline } = useMutation({
    ...declineInviteUserToOrganizationMutation(),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: usersCurrentUserQueryKey(),
      });
      await navigate({ to: "/bi" });
    },
  });
  return (
    <>
      <div className="flex justify-center items-center h-full ">
        <Card className="max-w-[400px] bg-secondary-800 text-secondary-300">
          <CardHeader className="flex gap-3">
            <div className="flex flex-col">
              <p className="text-md">
                {organization ? "You have been invited" : "Error"}
              </p>
            </div>
          </CardHeader>
          {organization && (
            <>
              <Divider />
              <CardBody>
                <p className="text-sm">
                  You have been invited to Organization {organization.name}.
                </p>
              </CardBody>
              <Divider />
              <CardFooter>
                <CustomButton
                  color="secondary"
                  className="mr-4"
                  onClick={() => decline({ path: { org_id: organization.id } })}
                >
                  Decline
                </CustomButton>
                <CustomButton
                  color="primary"
                  onClick={() => accept({ path: { org_id: organization.id } })}
                >
                  Accept
                </CustomButton>
              </CardFooter>
            </>
          )}
        </Card>
      </div>
    </>
  );
}

export const Route = createFileRoute("/_layout/invited")({
  component: () => <NoOrganization />,
  loader: async ({ context }) => {
    if (context.user?.organization_member?.status === "invited") {
      const orgId = context.user.organization_member.organization_id;
      return {
        organization: (await getOrganization({ path: { org_id: orgId } })).data,
      };
    }

    return { organization: null };
  },
});
